import { Stack, Theme } from '@mui/material';
import classNames from 'classnames';
import { FC, ReactNode } from 'react';
import Icon from '../icon';
import Text from '../text';
import { createUseStyles } from 'react-jss';
import { IconType } from '../icon/helpers';

interface Props {
  onClick: () => void;
  label?: string;
  icon?: IconType;
  image?: ReactNode;
  active?: boolean;
}

const useStyles = createUseStyles<string, { width: number }>((theme: Theme) => ({
  mobileMenuItem: {
    cursor: 'pointer',
    width: '100%',
    boxSizing: 'border-box',
    padding: '8px 4px',
    borderRadius: theme.shape.borderRadius,
    marginLeft: -4,
    '&.active': {
      backgroundColor: '#cccccc66',
    },
  },
}));

const MobileMenuItem: FC<Props> = ({
  onClick,
  label = '',
  icon,
  image: ImageEl,
  active = false,
}) => {
  const styles = useStyles();
  const compClass = classNames(styles.mobileMenuItem, { active });
  const hasLabel = !!label;
  const hasIcon = !!icon;
  const hasImage = !!ImageEl;

  return (
    <Stack
      gap={0.5}
      role="button"
      onClick={onClick}
      className={compClass}
      direction="row"
      justifyContent="flex-start"
      alignItems="center"
    >
      {hasIcon && <Icon name={icon} />}
      {hasImage && ImageEl}
      {hasLabel && (
        <Text size="small" dotdot>
          {label}
        </Text>
      )}
    </Stack>
  );
};

export default MobileMenuItem;
